import React from "react";
import WebhooksCard from "../components/WebhooksCard";

/** Alert destinations (Slack / Teams / PagerDuty / generic) — moved under Integrations. */
export default function IntegrationsWebhooks() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-1">Alert destinations</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          <strong>AeroGauge &rarr; chat.</strong> Get alerts and SLA breaches posted into a Slack or Teams channel, page someone through PagerDuty, or POST them to your own endpoint. Going the other way — a message in chat raising a ticket — is{" "}
          <a href="/inbound-channels" className="text-brand dark:text-brand-light hover:underline">
            Inbound chat channels
          </a>
          .
        </p>
      </div>
      <WebhooksCard />
    </div>
  );
}
